/**
 * D-266 - the non-blocking notices of a saved work log (POST /work-logs -> data.consumption), as i18n keys:
 *   sec.1: saved beyond the contract quota ("ממתין לאישור") / the hour bank ("נעולות", waits for a new bank);
 *   sec.3: the date is before the engagement's start ("התאריך לפני תחילת ההתקשרות", allowed).
 * Pure (unit-tested in utils/__tests__/workLogNotices.test.ts); none for a regular log.
 */
export function workLogNoticeKeys(res: unknown): string[] {
  const c = (res as { data?: { consumption?: { kind?: string; over_quota?: boolean; before_engagement_start?: boolean } | null } } | null | undefined)?.data?.consumption;
  const keys: string[] = [];
  if (c?.over_quota) keys.push(c.kind === 'hour_bank' ? 'consumption.savedBankLocked' : 'consumption.savedOverQuota');
  if (c?.before_engagement_start) keys.push('consumption.beforeStart');
  return keys;
}
